__turbopack_context__.v({
  "root": "Embed-module__9_3X-W__root",
});
